import { useState } from 'react';

const DEF_SEARCH_FILTER = {
  pageNo: 1,
  pageSize: 10,
  orderBy: 'name',
  order: 'ASC',
};

const getQs = (inData?) => {
  const { id } = nx.$root.params;
  if (!inData) {
    return {
      ...DEF_SEARCH_FILTER,
      coursewareId: id,
    };
  }
  return {
    ...DEF_SEARCH_FILTER,
    catalogues: inData.catalogues.join(),
    labels: inData.labels.join(),
    types: inData.types.join(),
    coursewareId: id,
    pageNo: inData.pageNo,
    pageSize: inData.pageSize,
  };
};

export const userCoursewareFilter = () => {
  const [busy, setBusy] = useState(false);

  const query = (inData) => {
    setBusy(true);
    nx.$api
      .coursewares_find_by_filter({ qs: inData })
      .then((res) => {
        nx.$root.preparation.searchResults = res.data;
      })
      .finally(() => {
        setBusy(false);
      });
  };

  const searchAll = () => {
    query(nx.param(getQs(null)));
  };

  const search = (value) => {
    if (value === null) return searchAll();
    const qsobj = { ...getQs(value), keyword: value.keyword };
    const qs = nx.param(qsobj, null, {
      transform: function (key, value) {
        return key + '=' + value;
      },
    });
    query(qs);
  };

  return { busy, search };
};
